export default __webpack_public_path__ + "static/media/foundNygma.2596aa64.wav";